import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface QuestionBankFilter {
  courseId: number | null;
  sectionId: number | null;
  topicId: number | null;
  subTopicId: number | null;
  difficultyLevel: number | null;
  questionType: number | null;
}

@Injectable({
  providedIn: 'root',
})
export class QuestionBankService {
  questionBankFilters = new BehaviorSubject<QuestionBankFilter>({
    courseId: null,
    sectionId: null,
    topicId: null,
    subTopicId: null,
    difficultyLevel: null,
    questionType: null,
  });

  constructor() {}

  getQuestionBankFilters(): Observable<QuestionBankFilter> {
    return this.questionBankFilters.asObservable();
  }

  setQuestionBankFilters(filter: QuestionBankFilter): void {
    this.questionBankFilters.next(filter);
  }
}
